import { routerRedux } from 'dva/router';

class Env {

    init(dva) {
        this.dva = dva;
    }

    dispatch(args) {
        this.dva._store.dispatch(args);
    }

	goto_page(link) {
		this.dva._store.dispatch(routerRedux.push(link));
	}

	goto_404() {
		this.dva._store.dispatch(routerRedux.replace('/error'));
    }

}

export default new Env();



// WEBPACK FOOTER //
// ./src/lib/env.js